import React from "react";
import moment from "moment";

export function getActorDisplayName(actor = {}) {
  const fullName = [actor.first_name, actor.last_name].filter(Boolean).join(" ").trim();

  return fullName || "Someone";
}

export function getNotificationId(notification = {}) {
  return notification.notification_id ?? notification.id ?? notification.comment_id ?? notification.card_id;
}

export function getNotificationRoute(notification = {}) {
  if (!notification.board_key || !notification.card_id) {
    return null;
  }

  const baseRoute = `/board/${notification.board_key}/${notification.board_key}-${notification.card_id}`;

  if (
    notification.event_type === "comment_tagged" &&
    notification.comment_id
  ) {
    const searchParams = new URLSearchParams({
      activityTab: "comment",
      comment_id: String(notification.comment_id),
    });

    return `${baseRoute}?${searchParams.toString()}`;
  }

  return baseRoute;
}

export function getNotificationTitle(notification = {}) {
  const actorName = getActorDisplayName(notification.actor);
  let message;

  switch (notification.event_type) {
    case "comment_tagged":
      message = "mentioned you in a comment";
      break;
    case "task_assigned":
      message = "assigned a ticket to you";
      break;
    default:
      message = "sent a notification";
      break;
  }

  return (
    <>
      <strong>{actorName}</strong> {message}
    </>
  );
}

export function getNotificationPreview(notification = {}) {
  const commentPreview =
    notification?.comment || 
    "";

  if (commentPreview) {
    return commentPreview.replaceAll('<p><br></p>','');
  }else{
    return notification?.card_title || ''
  }

  // switch (notification.event_type) {
  //   case "comment_tagged":
  //     return "Open the comment to see the full message.";
  //   case "task_assigned":
  //     return "Open the task to review the latest assignment.";
  //   default:
  //     return "Open the task to see more details.";
  // }
}

export function getNotificationTicketLabel(notification = {}) {
  if (!notification.board_key || !notification.card_id) {
    return "";
  }

  return `${notification.board_key}-${notification.card_id}`;
}

export function getNotificationRelativeTime(createdAt) {
  if (!createdAt) {
    return "";
  }

  return moment.utc(createdAt).local().fromNow();
}

export function getNotificationIconType(eventType) {
  switch (eventType) {
    case "comment_tagged":
      return "comment";
    case "task_assigned":
      return "assignment";
    default:
      return "notification";
  }
}

export function normalizeSocketNotification(message) {
  if (!message || typeof message !== "object") {
    return null;
  }

  const directNotification =
    hasNotificationShape(message) ? message :
    hasNotificationShape(message.data) ? message.data :
    hasNotificationShape(message.notification) ? message.notification :
    hasNotificationShape(message.data?.notification) ? message.data.notification :
    hasNotificationShape(message.payload) ? message.payload :
    hasNotificationShape(message.payload?.notification) ? message.payload.notification :
    null;

  return directNotification;
}

export function mergeNotifications(serverNotifications = [], liveNotifications = []) {
  const mergedMap = new Map();

  [...serverNotifications, ...liveNotifications].forEach((notification) => {
    const notificationId = getNotificationId(notification);

    if (notificationId === undefined || notificationId === null) {
      return;
    }

    const existingNotification = mergedMap.get(notificationId) || {};

    mergedMap.set(notificationId, {
      ...existingNotification,
      ...notification,
    });
  });

  return Array.from(mergedMap.values()).sort((first, second) => {
    const firstTime = first?.created_at ? new Date(first.created_at).getTime() : 0;
    const secondTime = second?.created_at ? new Date(second.created_at).getTime() : 0;

    return secondTime - firstTime;
  });
}

function hasNotificationShape(value) {
  return Boolean(value && typeof value === "object" && (value.notification_id || value.event_type));
}
